$ = require 'jquery'
Util = require 'app/scripts/lib/util'
View = require 'app/scripts/views/internal/view'
template = require 'app/scripts/views/templates/power_ups_voting_prefs'

module.exports = class VotingSettingsView extends View
  viewTitleKey: 'voting settings'

  initialize: ->
    @listenTo @model,
      'change:prefs': @render

  events:
    'click .js-voting-select:not(.disabled)': 'selectPerm'
    'click .js-vote-count-select:not(.disabled)': 'hideVotes'

  render: ->
    @$el.html(template({
      canChange: @model.editable()
      canSetObservers: @model.getOrganization()?.isFeatureEnabled('observers')
      canSetOrganization: @model.hasOrganization()
      canSetPublic: @model.isPublic()
      votingMode: @model.getPref('voting')
      hideVotes: @model.getPref('hideVotes')
    }))

    @

  selectPerm: (e) ->
    Util.stop(e)
    $target = $(e.target).closest('.js-voting-select')

    setting = $target.attr('name')
    @model.setPref('voting', setting)

  hideVotes: (e) ->
    Util.stop(e)
    $target = $(e.target).closest('.js-vote-count-select')
    @model.setPref('hideVotes', !@model.getPref('hideVotes'))
